import { DEBT_RECEIPT_DETAIL_PAGE } from "routes/route.constant";
import DetailDebtReceipt from "./DetailDebtReceipt";

const route = {
  path: DEBT_RECEIPT_DETAIL_PAGE,
  element: DetailDebtReceipt,
};

export default route;
